/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type TargetAttributeDtoType = typeof TargetAttributeDtoType[keyof typeof TargetAttributeDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TargetAttributeDtoType = {
  '@double': '@double',
  '@long': '@long',
  '@int': '@int',
  '@date': '@date',
  '@string': '@string',
  '@boolean': '@boolean',
  '@class': '@class',
  '@list': '@list',
} as const;
